import { entitlementsSelectors } from 'app-components/flux/entitlements';
import { getNavFromKey, navOrderV2, navSections, personalNavSections } from 'containers/App/paths';
import { useAppSelector } from 'hooks/redux';
import React, { useCallback } from 'react';
import { makeStyles } from 'tss-react/mui';
import { GroupNavItem, MainNavItem } from '../NavItems';
import { useNavExpansion } from '../NavExpansionContext';
import { NavSection } from '../NavSection';

const useStyles = makeStyles()(() => ({
  navPopover: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
}));

const LegacyNavItems = React.memo(function LegacyNavItems() {
  const businessEnabled = useAppSelector(entitlementsSelectors.getBusinessEnabled);

  const renderNavKey = useCallback(
    (navKey: string | readonly string[], idx: number) => {
      if (typeof navKey !== 'string') {
        if (navKey[0] === 'Business' && !businessEnabled) return null;
        return <GroupNavItem key={`group-${navKey[0]}-${idx}`} />;
      }
      const nav = getNavFromKey(navKey);
      if (nav) return <MainNavItem key={`nav-item-${nav.path}`} nav={nav} section='main' />;
      return null;
    },
    [businessEnabled],
  );

  return <>{navOrderV2.map(renderNavKey)}</>;
});

const SectionedNavItems = React.memo(function SectionedNavItems() {
  const businessEnabled = useAppSelector(entitlementsSelectors.getBusinessEnabled);

  return (
    <>
      {(businessEnabled ? navSections : personalNavSections).map((section) => (
        <NavSection key={section.id} section={section} />
      ))}
    </>
  );
});

export const NavPopoverV2 = React.memo(function NavPopoverV2(): React.JSX.Element {
  const { classes } = useStyles();
  const { collapsible: showSectionHeaders } = useNavExpansion();

  return <div className={classes.navPopover}>{showSectionHeaders ? <SectionedNavItems /> : <LegacyNavItems />}</div>;
});
